<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros-liquidacao-cji3 ref="liquidacaoCji3Params" @validation-change="onValidationChange" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-liquidacao-cji3"
            color="green"
            min-width="100"
            style="float: right;"
            :disabled="invalid || !canSave"
            :loading="loading"
            @click="salvarLiquidacaoCji3()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import LiquidacaoCji3Service from '@/services/LiquidacaoCji3Service';
import tourMixins from '@/mixins/tourMixins';

export default {
  name: 'LiquidacaoCji3Edit',

  mixins: [tourMixins],
  
  components: {
    ParametrosLiquidacaoCji3: () => import('@/components/liquidacaoCji3/ParametrosLiquidacaoCji3.vue')
  },
  
  mounted() {
    this.iniciarTourPagina();
  },

  data() {
    return {
      loading: false,
      formValid: false,
      arrTour: [
        {
          element: '#titulo-liquidacao-cji3',
          intro: 'Aqui você poderá inserir um nome para sua Liquidação da CJI3.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#codigos-obra-liquidacao-cji3',
          intro: 'Digite os códigos de obra, um por linha (obrigatório).',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#btn-save-liquidacao-cji3',
          intro: 'Após preencher os campos, clique aqui para salvar sua Liquidação da CJI3.',
          scrollTo: 'tooltip',
          position: 'left'
        },
      ],
    };
  },

  computed: {
    canSave() {
      return this.formValid;
    }
  },

  methods: {
    onValidationChange(isValid) {
      this.formValid = isValid;
    },

    salvarLiquidacaoCji3() {

      this.loading = true;
      
      try {
        const data = this.$refs.liquidacaoCji3Params.exportData();

        LiquidacaoCji3Service.salvarLiquidacaoCji3(data)
          .then(() => {
            this.$router.push({ name: 'Liquidação da CJI3 Histórico' });
            this.$toast.success('Liquidação da CJI3 salva com sucesso.', '', { position: 'topRight' });
          })
          .catch(err => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao salvar Liquidação da CJI3.', '', { position: 'topRight' });
          })
          .finally(() => this.loading = false);
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.message || 'Erro ao validar dados.', '', { position: 'topRight' });
      }
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  }
};
</script>


